import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../../src/data/static/strings'
import { RootStore } from '../../src/data/store'
import { apiTypes, geRequestDateTimeRoundOff, getCommaFormatedVal } from './../util/util'
import { APIEndPoints } from './APIEndpoints'
import { summaryConfig } from './config'

const responseParser = (data: any) => {
  const resp = data?.data

  const getTitle: any = {
    totalCount: 'Total Count',
    totalVolume: 'Total Value',
    successRate: 'Overall Success Rate',
    averageTicketSize: 'Average Ticket Size',
  }

  const getDuration: any = {
    '30 (in days)': '30 days',
    '7 (in days)': '7 days',
  }
  const summaries: any = []
  const keys = Object.keys(resp)

  const getRetData: any = {
    totalCount: {
      key: getTitle.totalCount,
      value: resp.totalCount?.totalRecordCount ?? '0',
      formatedVal: getCommaFormatedVal(Number(resp.totalCount?.totalRecordCount ?? '0'), true),
      marginPercent: resp.totalCount?.totalPercentCount ?? '0%',
      margin: resp.totalCount?.margin === 'increase' ? 1 : -1,
      duration: getDuration[resp.duration] ?? '',
    },
    totalVolume: {
      key: getTitle.totalVolume,
      value: `${Number(resp.totalVolume?.totalRecordVolume ?? '0')}`,
      formatedVal: getCommaFormatedVal(Number(resp.totalVolume?.totalRecordVolume ?? '0'), false),
      marginPercent: resp.totalVolume?.totalPercentVolume ?? '0%',
      margin: resp.totalVolume?.margin === 'increase' ? 1 : -1,
      duration: getDuration[resp.duration] ?? '',
    },
    successRate: {
      key: getTitle.successRate,
      value: `${resp.successRate?.successRatio ?? '0'}%`,
      formatedVal: `${resp.successRate?.successRatio ?? '0'}%`,
      marginPercent: resp.successRate?.successPercent ?? '0%',
      margin: resp.successRate?.margin === 'increase' ? 1 : -1,
      duration: getDuration[resp.duration] ?? '',
    },
    averageTicketSize: {
      key: getTitle.averageTicketSize,
      value: `${resp.averageTicketSize?.avgticketAmt ?? '0'}`,
      formatedVal: getCommaFormatedVal(Number(resp.averageTicketSize?.avgticketAmt ?? '0'), false),
      marginPercent: resp.averageTicketSize?.avgticketPercent ?? '0%',
      margin: resp.averageTicketSize?.margin === 'increase' ? 1 : -1,
      duration: getDuration[resp.duration] ?? '',
    },
  }
  keys.map((item: any) => {
    if (Object.keys(getTitle).includes(item)) {
      summaries.push(getRetData[item])
    }
  })
  return summaries
}

const getInsightsSummary = (tokens: any, reqBody: any) => {
  const isCustomRange =
    RootStore.insights.graphPrefrences.selectedDate.dateLabel === actionMenuStrings.customDate ||
    RootStore.insights.graphPrefrences.dateValue === actionMenuStrings.customDate
  //|| RootStore.insights.graphPrefrences.selectedDate.dateLabel === actionMenuStrings.yesterday
  //console.log('isCustomRange', isCustomRange)
  const request: Request<{}> = {
    config: summaryConfig(tokens, ''),
    apiPath: APIEndPoints.getTxnsInsightsSummary,
    method: 'POST',
    cache: false,
    body: isCustomRange
      ? reqBody
      : geRequestDateTimeRoundOff(reqBody, RootStore.insights.graphPrefrences.selectedDate, apiTypes.INSIGHT_SUMMERY),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { getInsightsSummary }
